import { showNotification } from '@helpers/notification-helper';
import { useAppSelector } from '@hooks/app/redux';
import asyncWrap from '@lib/utils/promise/asyncWrap';
import { addToMyClients } from '@services/external/client.api';
import { Modal } from '@ui';
import React from 'react';
import { IClientSearchItem, TClientPairingStatus } from 'types/client.types';

interface AddToPatientsModalProps {
  visible: boolean;
  mode?: TClientPairingStatus;
  client?: IClientSearchItem;

  onClose: () => void;
  afterSubmit: () => void;
}

const AddToPatientsModal: React.FunctionComponent<AddToPatientsModalProps> = ({
  visible,
  onClose,
  mode,
  afterSubmit,
  client,
}) => {
  const [loading, setLoading] = React.useState(false);
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;
  const title = mode === 'paired' ? 'Pridanie pacienta pacienta' : 'Odmietnutie pacienta';

  const handlePairing = React.useCallback(async () => {
    if (!client || !mode) {
      return;
    }

    setLoading(true);
    const [, error] = await asyncWrap(addToMyClients(providerId, client.id));

    if (error) {
      showNotification({
        title: 'Niečo sa pokazilo',
        copy: '',
        type: 'ERROR',
      });
    } else {
      afterSubmit();
      onClose();
      showNotification({
        title: 'Operácia prebehla úspešne',
        copy: '',
        type: 'SUCCESS',
      });
    }

    setLoading(false);
  }, [client, mode]);

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      destroyOnClose
      footer={
        <Modal.Actions
          actions={[
            { key: 'cancel', label: 'Zrušiť', variant: 'ghost', onClick: onClose },
            {
              key: 'submit',
              label: mode === 'paired' ? 'Prijať' : 'Odmietnuť',
              variant: mode === 'paired' ? 'primary' : 'danger',
              onClick: handlePairing,
              loading,
            },
          ]}
        />
      }
      title={title}
    >
      <Modal.Title>{`${title}: ${client?.profile.firstName} ${client?.profile.lastName}`}</Modal.Title>
      <Modal.Description>
        {mode === 'paired'
          ? 'Naozaj chcete pridať pacienta pod svojich pacientov, a umožniť mu komunikovať s Vami?'
          : 'Naozaj chcete odmietnuť pacienta?'}
      </Modal.Description>
    </Modal>
  );
};

export default React.memo(AddToPatientsModal);
